module.exports = __webpack_public_path__ + "static/media/UNI-logo.310c8cef.png";